import { jsx as _jsx } from "react/jsx-runtime";
// -------------------------------------------------------
// NOTE: This is a generated file, do not manually modify!
// -------------------------------------------------------
import { SvgIcon } from '@mui/material';
const paths = [
    'M8 2C4.68548 2 2 4.70968 2 8C2 11.3145 4.68548 14 8 14C11.2903 14 14 11.3145 14 8C14 4.70968 11.2903 2 8 2ZM4.29839 11.7016C2.33871 9.76613 2.26613 6.64516 4.03226 4.58871L11.4113 11.9677C9.35484 13.7339 6.23387 13.6613 4.29839 11.7016ZM11.9435 11.4355L4.56452 4.05645C6.62097 2.29032 9.74194 2.3629 11.6774 4.32258C13.6371 6.25806 13.7097 9.37903 11.9435 11.4355Z',
];
export const Ban = (props) => (_jsx(SvgIcon, Object.assign({ viewBox: "0 0 16 16" }, props, { children: paths.map((pathString, i) => (_jsx("path", { d: pathString }, i))) })));
Ban.iconCategory = 'ui';
